// Utility function to format "Last Seen" time
export const formatLastSeen = (lastSeenDate) => {
    if (!lastSeenDate) return 'Never';

    const now = new Date();
    const lastSeen = new Date(lastSeenDate);
    const diffMs = now - lastSeen;
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30.44); // Use average days per month for better accuracy
    const diffYears = Math.floor(diffDays / 365.25); // Use average days per year for better accuracy

    // Fix: Use a more common "less than a minute" text like 'A moment ago'
    if (diffSecs < 60) return 'A moment ago';
    
    if (diffMins < 60) return `${diffMins} ${diffMins === 1 ? 'minute' : 'minutes'} ago`;
    if (diffHours < 24) return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    
    // FIX APPLIED HERE: Corrected the termination of the 'days' string.
    if (diffDays < 30) return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
    
    // Using diffDays directly for Months and Years is usually better for relative time
    if (diffDays < 365) return `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'} ago`;
    
    return `${diffYears} ${diffYears === 1 ? 'year' : 'years'} ago`;
};

// Component for rendering online status badge
export const OnlineStatusBadge = ({ isOnline, lastSeen, showLastSeen = true }) => {
    if (isOnline) {
        return (
            <span className="inline-flex items-center gap-1 text-xs font-medium text-green-600">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                Online
            </span>
        );
    }

    if (showLastSeen && lastSeen) {
        return (
            <span className="text-xs text-gray-500 flex items-center gap-1">
                <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
                Last seen {formatLastSeen(lastSeen)}
            </span>
        );
    }

    return null;
};

export default { formatLastSeen, OnlineStatusBadge };